// extracted by mini-css-extract-plugin
export default {"wrapperSearch":"style_wrapperSearch__TJtN2","search":"style_search__FKFam"};